import { render, staticRenderFns } from "./goodsReceipt.vue?vue&type=template&id=43f70a68&scoped=true"
import script from "./goodsReceipt.vue?vue&type=script&lang=js"
export * from "./goodsReceipt.vue?vue&type=script&lang=js"
import style0 from "./goodsReceipt.vue?vue&type=style&index=0&id=43f70a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f70a68",
  null
  
)

export default component.exports